export default {
    message: {
        tiers: {
            t1: {
                label: "独立部署",
                desc: "<p>统一对所有虚拟、网页和 SaaS 应用程序的访问方式，借助端到端的上下文安全控制措施保护用户、应用程序和数据。</p><p>为网络、SaaS、虚拟和移动应用程序提供免 VPN 代理及 SSO，同时提供保护，免受恶意内容、键盘记录和屏幕捕捉恶意软件的侵害。</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>适用于需要具有精细安全性的全数字化工作空间，但不需要虚拟应用与桌面的员工的完整工作空间解决方案。</p><p>包括 Workspace Standard 功能，以及针对 SaaS 和 web 的高端安全控件、统一的端点管理和 Content Collaboration Premium。</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>包括 Citrix Virtual Apps and Desktops 混合部署选项的全面的工作空间解决方案。</p><p>包括 Workspace Premium 功能，以及适用于 Citrix Virtual Apps and Desktops 的云管理选项。</p>"
            }
        }
    }
}